import React, { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from './ModalComponents';
import { useCancelPaidOfferMutation } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { BorderLine } from '../border-line';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';
import { useIsSmallScreen } from '../../hooks';

interface OfferCancelPaidModalType {
  data: {
    id: string;
    number: string;
    price: number;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const offerCancelPaidModal: OfferCancelPaidModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const OfferCancelPaidModal = () => {
  const { mutate } = useCancelPaidOfferMutation();
  const isSmallScreen = useIsSmallScreen();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    offerCancelPaidModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    offerCancelPaidModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: offerCancelPaidModal.data[0].id },
      {
        onSuccess: () => {
          setOpen(false);
          offerCancelPaidModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.OFFER.ERROR.NOT_CANCELED_PAID, 'error');
        },
      },
    );
  };

  return (
    <ModalBase
      id={'offer-cancel-paid-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.offerCancelPaidTitle', {
            count: offerCancelPaidModal.data.length,
            total: offerCancelPaidModal.data.reduce((acc, item) => acc + Number(item.price), 0),
          })}
        </Typography>
        <ModalBodyCustomColumns columns={'1fr'}>
          {offerCancelPaidModal.data.map((item, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <BorderLine space={'none'} />}
              <ModalBodyCustomColumns columns={'1fr max-content'}>
                <Typography variant={'textM'}>{item.number}</Typography>
                <Typography variant={'textM'}>{item.price}$</Typography>
              </ModalBodyCustomColumns>
            </React.Fragment>
          ))}
        </ModalBodyCustomColumns>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'destructive'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
